import { Badge } from "@/components/ui/badge";
import type { ReportStatus } from "@/types";

const LABELS: Record<ReportStatus, string> = {
  open: "Otwarte",
  resolved: "Rozwiązane",
};

interface Props {
  status: ReportStatus;
}

export function ReportStatusBadge({ status }: Props) {
  return <Badge variant={status === "open" ? "default" : "secondary"}>{LABELS[status]}</Badge>;
}
